export default __webpack_public_path__ + "812aada3dcddc2628a109156c45bc8ee.png";